"use client";

import type { Dispatch, SetStateAction } from "react";
import { createContext } from "react";

export type ConsentContext = {
  consent: number[];
  voluntaryConsent: number[];
  isConsenting: boolean;
  isError: boolean;
  isLoading: boolean;
  setConsent: Dispatch<SetStateAction<number[]>>;
  setIsError: Dispatch<SetStateAction<boolean>>;

  /** TODO: remove/improve when ConsentModal/CookieManager are improved */
  isConsentModalVisible: boolean;
  saveConsent: (props: Pick<ConsentContext, "consent">) => Promise<void>;
  setIsConsentModalVisible: Dispatch<SetStateAction<boolean>>;
};

export const consentContext = createContext<ConsentContext>({
  consent: [],
  voluntaryConsent: [],
  isConsenting: false,
  isError: false,
  isLoading: true,
  setIsError: () => {},
  setConsent: () => {},
  /** TODO: remove/improve when ConsentModal/CookieManager are improved */
  isConsentModalVisible: false,
  saveConsent: () => Promise.resolve(),
  setIsConsentModalVisible: () => {},
});
